import { Component, OnInit,Inject,ViewChild,ElementRef } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-call-recording-modal',
  templateUrl: './call-recording-modal.component.html',
  styleUrls: ['./call-recording-modal.component.scss']
})
export class CallRecordingModalComponent implements OnInit {

  @ViewChild('audioPlayer') audioPlayer:ElementRef

  constructor(
    public dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    setTimeout(() =>{
        this.play();
    },100)
  }

  play() {
    this.audioPlayer.nativeElement.play();
  }

  pause() {
    this.audioPlayer.nativeElement.pause();
  }

  stop() {
    this.audioPlayer.nativeElement.currentTime = 0;
    this.audioPlayer.nativeElement.pause();
  }


  closeDialog(){
    this.dialog.closeAll();
    this.stop();
    
  }

 

}
